module.exports = new __parcel__URL__("bossfight_boss_mythical.41519033.png").toString();